module.exports = __webpack_public_path__ + "static/media/hamburger-menu-patient.b1507b70.svg";